var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { hexToRgba } from '../helpers';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
var linkStaticStyle = css({
    '&:hover': {
        backgroundColor: theme.background.hover,
    },
    backgroundColor: hexToRgba(tokens.colors.white, 0.01),
    borderRadius: tokens.borderRadius.medium,
    boxDecorationBreak: 'clone',
    color: theme.text.link,
    display: 'inline',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontSize: 'inherit',
    fontWeight: tokens.fontWeights.bold,
    lineHeight: 'inherit',
    outline: 0,
    textDecoration: 'underline',
    textDecorationColor: 'transparent',
    textDecorationThickness: '1.25px',
    transition: 'box-shadow 125ms ease-out, background-color 125ms ease-out, text-decoration-color 125ms ease-out',
});
export function linkStyle(_a) {
    var inverted = _a.inverted, isFocusVisible = _a.isFocusVisible, size = _a.size;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        linkStaticStyle,
        css(__assign(__assign({}, (size !== 'inherit' && {
            fontSize: tokens.fontSizes[size],
            lineHeight: tokens.lineHeights.relaxed,
        })), (isFocusVisible
            ? {
                boxShadow: "0 0 0 2px ".concat(theme.border.focusOutline),
            }
            : {
                '&:hover': {
                    boxShadow: "0 0 0 2px ".concat(theme.background.hover),
                    textDecorationColor: theme.text.link,
                },
            }))),
    ], false);
}
export var iconStyle = css({
    marginTop: '-2px',
    verticalAlign: 'middle',
});
export function innerContentStyle(_a) {
    var hasLeftIcon = _a.hasLeftIcon, hasRightIcon = _a.hasRightIcon, iconSize = _a.iconSize;
    var gap = iconSize === 'small' ? '2px' : tokens.spacing.xsmall;
    return css(__assign(__assign({}, (hasLeftIcon && { paddingLeft: gap })), (hasRightIcon && { paddingRight: gap })));
}
